import { __spreadArray } from "tslib";
import * as React from 'react';
import * as moment from 'moment-timezone';
import { CalendarCellTimes } from 'wix-ui-tpa/dist/src/components/CalendarCell/types';
import TableCell from '../../containers/TableCell/TableCell';
import { isWeekEnd, getDayByWeekStarter, getMonthDays, } from '../../containers/Calendar/CalendarUtlis/CalendarUtils';
import MonthlyHeaders from './MonthlyHeaders/MonthlyHeaders';
import MomentEnum from '../../../enums/MomentEnum';
import { st, classes } from './MonthlyTable.st.css';
var MonthlyTable = function (props) {
    var tableArray = [];
    var getBeforeMonthFillers = function () {
        var beforeFillersToReturn = [];
        var beforeFillers = props.beforeFillers;
        var _loop_1 = function (day) {
            var events = beforeFillers[day];
            var timeType = CalendarCellTimes.pastDate;
            //@ts-ignore
            beforeFillersToReturn.push(function (line) {
                return tableCell({ line: line, events: events, day: day, timeType: timeType });
            });
        };
        for (var day in beforeFillers) {
            _loop_1(day);
        }
        return beforeFillersToReturn;
    };
    var keyUpHandler = function (event) {
        if (event.keyCode === 13) {
            return props.focusEvent();
        }
    };
    var keyClickHandler = function (event, x, y, lines, events) {
        var isMobile = props.isMobile, onSelectCell = props.onSelectCell;
        if (event.shiftKey && event.keyCode === 9) {
            // shift + tab
            if (!events.length || isMobile) {
                if (x > 0) {
                    x--;
                }
                else if (y > 0) {
                    x = 6;
                    y--;
                }
                else if (x === 0 && y === 0) {
                    return onSelectCell('');
                }
            }
            return onSelectCell(tableArray[x][y]);
        }
        switch (event.keyCode) {
            case 9: // tab
                if (!events.length || isMobile) {
                    if (x < 6) {
                        x++;
                    }
                    else if (y < lines) {
                        x = 0;
                        y++;
                    }
                }
                break;
            case 37: // left
                if (x > 0) {
                    x--;
                }
                break;
            case 38: // down
                if (y > 0) {
                    y--;
                }
                break;
            case 39: // right
                if (x < 6) {
                    x++;
                }
                break;
            case 40: // up
                if (y < tableArray.length) {
                    y++;
                }
                break;
            default:
                return;
        }
        onSelectCell(tableArray[x][y]);
    };
    var tableCell = function (_a) {
        var line = _a.line, events = _a.events, day = _a.day, timeType = _a.timeType, _b = _a.current, current = _b === void 0 ? false : _b;
        return function (lines) { return cellByLines({ lines: lines, line: line, day: day, events: events, timeType: timeType, current: current }); };
    };
    var cellByLines = function (_a) {
        var lines = _a.lines, line = _a.line, day = _a.day, events = _a.events, timeType = _a.timeType, _b = _a.current, current = _b === void 0 ? false : _b;
        var isMobile = props.isMobile, renderCell = props.renderCell, weekStarter = props.weekStarter, localeToggle = props.localeToggle, alignment = props.alignment, isStretchable = props.isStretchable, onSelectCell = props.onSelectCell, selectedTime = props.selectedTime, isBorderShown = props.isBorderShown, isTodayClicked = props.isTodayClicked, timezone = props.timezone;
        var dayToDisplay = moment(day).format(MomentEnum.dayOfMonth);
        var weekDay = moment(day).format(MomentEnum.dayOfWeek);
        var horizonalPosition = getDayByWeekStarter(weekDay, weekStarter);
        var isRightPopper = horizonalPosition < 3;
        var popperStyle = isRightPopper
            ? { left: '6px !important' }
            : { left: '-6px !important' };
        var horizonal = isRightPopper ? 'right' : 'left';
        //@ts-ignore
        var vertical = popperVerticalByLines[line](line, lines);
        var popperPlacement = vertical ? "".concat(horizonal, "-").concat(vertical) : horizonal;
        var weekEnd = isWeekEnd(day, weekStarter);
        var cellStyle = isStretchable
            ? { height: "calc((100vh - 100px - 40px - 34px) / ".concat(lines, ")") }
            : {};
        var selected = selectedTime === day;
        if (tableArray[horizonalPosition]) {
            //@ts-ignore
            tableArray[horizonalPosition][line - 1] = day;
        }
        else {
            //@ts-ignore
            tableArray[horizonalPosition] = [day];
        }
        return (React.createElement(TableCell, { key: day, timeToDisplay: dayToDisplay, events: events, time: day, render: renderCell, popperPlacement: popperPlacement, popperStyle: popperStyle, localeToggle: localeToggle, timeType: timeType, current: current, alignment: alignment, isStretchable: isStretchable, isWeekEnd: weekEnd, isMobile: isMobile, onSelectCell: onSelectCell, isBorderShown: isBorderShown, isTodayClicked: isTodayClicked, cellStyle: cellStyle, keyClickHandler: function (e) {
                return keyClickHandler(e, horizonalPosition, line - 1, lines, events);
            }, selected: selected, onKeyUp: keyUpHandler, timezone: timezone, focusEvent: props.focusEvent }));
    };
    var popperVerticalByLines = [
        function () { return 'start'; },
        function () { return 'start'; },
        function () { return ''; },
        function () { return ''; },
        function (line, lines) { return (lines === line ? 'end' : ''); },
        function (line, lines) { return (lines === line ? 'end' : ''); },
        function (line, lines) { return (lines === line ? 'end' : ''); },
    ];
    var getAfterMonthFillers = function (line) {
        var fillers = [];
        var afterFillers = props.afterFillers;
        var _loop_2 = function (day) {
            var timeType = CalendarCellTimes.futureDate;
            var events = afterFillers[day];
            //@ts-ignore
            fillers.push(function () {
                return cellByLines({ lines: line, line: line, day: day, timeType: timeType, events: events });
            });
        };
        for (var day in afterFillers) {
            _loop_2(day);
        }
        return fillers;
    };
    var getTotalCells = function () {
        var blanks = getBeforeMonthFillers();
        var days = props.days, dateObject = props.dateObject;
        var daysInMonth = getMonthDays({
            days: days,
            dateObject: dateObject,
            daysInserter: monthlyDaysInserter,
        });
        var totalCells = __spreadArray(__spreadArray([], blanks, true), daysInMonth, true);
        return totalCells;
    };
    var monthlyDaysInserter = function (_a) {
        var events = _a.events, day = _a.day, timeType = _a.timeType, isCurrentMonth = _a.current;
        return function (line) {
            return tableCell({ line: line, events: events, day: day, timeType: timeType, current: isCurrentMonth });
        };
    };
    var getTableBody = function () {
        var totalCells = getTotalCells();
        var rows = [];
        var currentCellsRow = [];
        totalCells.forEach(function (cell, i) {
            if (i % 7 !== 0) {
                //@ts-ignore
                currentCellsRow.push(cell(rows.length));
            }
            else {
                rows.push(currentCellsRow);
                currentCellsRow = [];
                //@ts-ignore
                currentCellsRow.push(cell(rows.length));
            }
            if (i === totalCells.length - 1) {
                rows.push(currentCellsRow);
            }
        });
        if (totalCells.length % 7 !== 0) {
            var fillers = getAfterMonthFillers(rows.length - 1);
            rows[rows.length - 1] = rows[rows.length - 1].concat(fillers);
        }
        return rows.map(function (row, i) { return (React.createElement("tr", { key: i }, row.map(function (createCell) { return createCell(rows.length - 1); }))); });
    };
    var tableBody = getTableBody();
    return (React.createElement("div", { className: st(classes.MonthlyTable, {
            isStretchable: props.isStretchable,
        }) },
        React.createElement("table", { "aria-labelledby": props.month, className: classes.Table, cellSpacing: "0", cellPadding: "0" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement(MonthlyHeaders, { weekStarter: props.weekStarter, localeToggle: props.localeToggle, alignment: props.alignment, isMobile: props.isMobile, locale: props.locale }))),
            React.createElement("tbody", null, tableBody))));
};
export default MonthlyTable;
//# sourceMappingURL=MonthlyTable.js.map